import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const PackagePose = ApplicationRecord.extend({
  static: {
    jsonapiType: 'package_poses',
  },
  attrs: {
    poseNumber: attr(),
    season: attr(),
    package: belongsTo(),
    background: belongsTo(),
    foreground: belongsTo(),
  }
});

export default PackagePose;
